module.exports = __webpack_public_path__ + "static/media/ch-chilli.f8a9b397.jpeg";